import { call, put, takeLatest } from 'redux-saga/effects';
import { cancelDebitNoteFailure, cancelDebitNoteRequest, cancelDebitNoteSuccess } from './debitNotesSlice';
import { apiClient } from '../../utils/axios';

function* cancelDebitNoteSaga(action) {
  try {
    const { url, reason } = action.payload;
    const data = { reason };
    const response = yield call(apiClient.put, url, data);
    yield put(cancelDebitNoteSuccess(response.data));
  } catch (error) {
    yield put(cancelDebitNoteFailure(error.response?.data?.errors));
  }
}

function* debitNotesSaga() {
  yield takeLatest(cancelDebitNoteRequest.type, cancelDebitNoteSaga);
}

export default debitNotesSaga;
